<template>
    <v-container>
            <div class="d-flex">
                    <Calendar
                        :columns="$screens({ default: 1, lg: 2 })"
                        @dayclick="onDate"
                        :attributes='calendar_attrs'
                        :locale="{id:$i18n.locale }"
                        :available-dates="available_dates"
                    >
                    </Calendar>
                    <v-card class="ml-4 pl-2 pr-2">

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_1"
                                    @change="(val)=>{header_1=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 1"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_2"
                                    @change="(val)=>{header_2=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 2"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col><v-col cols="12" md="4">
                                <v-select
                                    :value="header_3"
                                    @change="(val)=>{header_3=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 3"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_4"
                                    @change="(val)=>{header_4=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 4"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_5"
                                    @change="(val)=>{header_5=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 5"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col><v-col cols="12" md="4">
                                <v-select
                                    :value="header_6"
                                    @change="(val)=>{header_6=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 6"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_7"
                                    @change="(val)=>{header_7=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 7"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_8"
                                    @change="(val)=>{header_8=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 8"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col><v-col cols="12" md="4">
                                <v-select
                                    :value="header_9"
                                    @change="(val)=>{header_9=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 9"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_10"
                                    @change="(val)=>{header_10=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 10"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_11"
                                    @change="(val)=>{header_11=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 11"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col><v-col cols="12" md="4">
                                <v-select
                                    :value="header_12"
                                    @change="(val)=>{header_12=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 12"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_13"
                                    @change="(val)=>{header_13=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 13"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    :value="header_14"
                                    @change="(val)=>{header_14=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 14"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col><v-col cols="12" md="4">
                                <v-select
                                    :value="header_15"
                                    @change="(val)=>{header_15=val}"
                                    :items="header_items"
                                    item-text="name"
                                    item-value="value"
                                    label="Column 15"
                                    return-object
                                    outlined
                                    dense
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card> 
            </div>

            <v-row class="mt-4 mb-8">
                <v-col cols="8" class="criteria" >
                    <v-select v-model="selectedStatus" :items="status_items" label="สถานะของนัดหมาย" 
                        
                        item-text="name"
                        item-value="value" multiple chips hide-details>
                    </v-select>
                </v-col>
                <v-col class="text-left">
                    <v-btn style="color:white" depressed @click="reload()" color="purple">Apply Change</v-btn>
                </v-col>
                <v-col class="text-left">
                    <v-btn tile style="color:white" color="green" @click="csvExport()">
                    <v-icon left>mdi-table-arrow-down</v-icon>Export CSV
                </v-btn>
                </v-col>
            </v-row>

            <v-card style="margin-top:5px;">
                <v-data-table
                    :headers="headers"
                    :items="rows"
                    :items-per-page="10"
                    class="elevation-1"
                >

                    <template v-slot:item.reservation_status_id="{ item }">
                        <div v-if="item.callback_status!=undefined">
                            <div v-if="item.callback_status.type=='call_wait'">
                                <div v-if="item.callback_status.is_completed > 0">
                                    {{ $t('reservation_status_' + item.reservation_status_id) }}
                                </div>
                                <div v-else-if="item.callback_status.is_called > 0">
                                    <v-btn :loading="item.loading" depressed color="yellow" @click="callWait(item.reservation_id,1,0)">{{ $t('callback_status_call_wait_called') }} {{item.callback_status.is_called}} {{ $t('callback_status_call_wait_time') }}</v-btn>
                                    <v-btn class="ml-1" depressed color="red" @click="callWait(item.reservation_id,0,1)">{{ $t('callback_status_call_wait_complete') }}</v-btn>
                                </div>
                                <div v-else>
                                    <v-btn :loading="item.loading" depressed color="green" @click="callWait(item.reservation_id,1,0)">{{ $t('callback_status_call_wait_calling') }}</v-btn>
                                    <v-btn class="ml-1" depressed color="red" @click="callWait(item.reservation_id,0,1)">{{ $t('callback_status_call_wait_complete') }}</v-btn>
                                </div>
                            </div>
                            <div v-else>{{ $t('reservation_status_' + item.reservation_status_id) }}</div>
                        </div>
                        <div v-else>{{ $t('reservation_status_' + item.reservation_status_id) }}</div>
                    </template>

                    <template v-slot:item.status_datetime="{ item }">
                        <div>{{ item.status_datetime.substring(0,10) + ' ' + item.status_datetime.substring(11,19) }}</div>                      
                    </template>

                    <template v-slot:item.reservation_date="{ item }">
                        <div>{{ item.reservation_date.substring(0,10) }}</div>
                    </template>

                    <template v-slot:item.reservation_timestart&reservation_timeend="{ item }">
                        <div>{{ item.reservation_timestart + ' - ' +  item.reservation_timeend}}</div>
                    </template>

                    <template v-slot:item.line_name&line_logo="{ item }">
                        <div>{{ item.line_name }}</div>
                    </template>

                </v-data-table>
            </v-card>
    </v-container>
</template>

<style scoped>
    .criteria {
        padding-top: 0px;
        padding-bottom: 0px;
    }
</style>
<script>

import Calendar from 'v-calendar/lib/components/calendar.umd'
import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'

export default {
    props: ["station_code"],
    components: {
        Calendar
    },
    data () {
        return {
            select_date: null,
            available_dates : [],
            calendar_attrs : [{
                bar: 'purple',
                dates: new Date(),
            }],
            header_items : [
                {name: 'ไม่แสดง', value: 'none'},
                {name: 'สถานะ', value: 'reservation_status_id'},
                {name: 'อัพเดทเมื่อ', value: 'status_datetime'},
                {name: 'กลุ่มงานบริการ', value: 'group_name'},
                {name: 'หมายเหตุ', value: 'extranote'},
                {name: 'วันที่จอง', value: 'reservation_date'},
                {name: 'ช่วงเวลาที่จอง', value: 'reservation_timestart&reservation_timeend'},
                {name: 'LINE', value: 'line_name&line_logo'},
                {name: 'member_form_1', value: 'member_form_1'},
                {name: 'member_form_2', value: 'member_form_2'},
                {name: 'member_form_3', value: 'member_form_3'},
                {name: 'member_form_4', value: 'member_form_4'},
                {name: 'member_form_5', value: 'member_form_5'},
            ],
            header_1 : {name: 'ไม่แสดง', value: 'none'},
            header_2 : {name: 'ไม่แสดง', value: 'none'},
            header_3 : {name: 'ไม่แสดง', value: 'none'},
            header_4 : {name: 'ไม่แสดง', value: 'none'},
            header_5 : {name: 'ไม่แสดง', value: 'none'},
            header_6 : {name: 'ไม่แสดง', value: 'none'},
            header_7 : {name: 'ไม่แสดง', value: 'none'},
            header_8 : {name: 'ไม่แสดง', value: 'none'},
            header_9 : {name: 'ไม่แสดง', value: 'none'},
            header_10 : {name: 'ไม่แสดง', value: 'none'},
            header_11 : {name: 'ไม่แสดง', value: 'none'},
            header_12 : {name: 'ไม่แสดง', value: 'none'},
            header_13 : {name: 'ไม่แสดง', value: 'none'},
            header_14 : {name: 'ไม่แสดง', value: 'none'},
            header_15 : {name: 'ไม่แสดง', value: 'none'},
            headers:[],
            rows: [],
            query : {
                station_code : this.station_code
                ,fields : ["reservation_status_id","group_name","reservation_date","reservation_timestart","reservation_timeend","member_id","line_name","line_logo","callback_status","status_datetime","extranote","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5"]
                ,query : {
                    station_code_list:[this.station_code]
                    ,status_id_list:["1","2","3","4","5","6","7","8","9"]
                }
                ,order : ""
                ,page : 1
            },
            registerformlist : [],
            status_items : [
                {name:this.$i18n.t('reservation_status_1'),value:"1"}
                ,{name:this.$i18n.t('reservation_status_2'),value:"2"}
                ,{name:this.$i18n.t('reservation_status_3'),value:"3"}
                ,{name:this.$i18n.t('reservation_status_4'),value:"4"}
                ,{name:this.$i18n.t('reservation_status_5'),value:"5"}
                ,{name:this.$i18n.t('reservation_status_7'),value:"7"}
                ,{name:this.$i18n.t('reservation_status_8'),value:"8"}
                ,{name:this.$i18n.t('reservation_status_9'),value:"9"}
            ]
            ,selectedStatus : ["1","2","3","4","5","7","8","9"]
        }
    },
    methods: {
        csvExport() {
            var rearragedata = []
            this.rows.forEach(r=>{
                var value = []
                this.headers.forEach(h=>{
                    var val = ""
                    h = h.value.split('&')[0]
                    if(h=='reservation_status_id'){
                        val = this.$t('reservation_status_' + r.reservation_status_id)
                    }
                    else if(h=='status_datetime'){
                        val = r.status_datetime.substring(0,10) + ' ' + r.status_datetime.substring(11,19)
                    }
                    else if(h=='reservation_date'){
                        val = r.reservation_date.substring(0,10)
                    }
                    else if(h=='reservation_timestart'){
                        val = r.reservation_timestart + ' - ' +  r.reservation_timeend
                    }
                    else{
                        val = r[h] != undefined ? r[h] : ""
                    }
                    val = val.replace(',','|')
                    value.push(val)
                })
                rearragedata.push(value.join(','))
            })
            let csvContent = "data:text/csv;charset=utf-8," + "\ufeff";
            csvContent += [
                this.headers.map(h=>h.text).join(","),
                ...rearragedata
            ].join("\n");
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "appointment_list_" + this.select_date + ".csv");
            link.click();
        },
        reload(){

            this.query.query.status_id_list = this.selectedStatus
            this.query.fields = ['reservation_id']
            this.headers = []

            for(var i=1;i<=15;i++){
                if(this['header_'+i].value != 'none'){
                    this.query.fields = this.query.fields.concat(this['header_'+i].value.split('&'))
                    this.headers.push({
                        text:this['header_'+i].name
                        ,value:this['header_'+i].value
                    })
                }
            }

            for(var j=5;j>0;j--){
                this.headers.forEach((v,i,arr)=>{
                    if(v.value=='member_form_'+j){
                        if(this.registerformlist.length>=j){
                            arr[i].text = this.$i18n.t('form_tag_'+this.registerformlist[j-1].form_tag)
                        }else{
                            arr.splice(i, 1);
                        }
                    }
                })
            }

            axios.post(config.api.url.manage.staff.update_savesession,{
                'savesession_url'  : document.location.pathname
                ,'savesession_value' : JSON.stringify(this.query)
            },{ headers: Staff.getTokenHeader()})



            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.appointmentlist,this.query,{ headers: Staff.getTokenHeader()})
            .then(response => {

                this.selected = []
                this.rows = response.data.reservationlist
                this.rows.forEach((r,i,arr)=>{

                    if(r.reservation_date!=undefined){
                        var d = new Date(r.reservation_date);
                        d.setHours(d.getHours()+7);
                        arr[i]['reservation_date'] = d.toISOString().substring(0,10);
                    }

                    if(r.status_datetime!=undefined){
                        d = new Date(r.status_datetime);
                        d.setHours(d.getHours()+7);
                        arr[i]['status_datetime'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);
                    }

                    if(r.reservation_timestart!=undefined){
                        r.reservation_timestart = '0000' + r.reservation_timestart;
                        r.reservation_timestart = r.reservation_timestart.substring(r.reservation_timestart.length-4,r.reservation_timestart.length);
                        arr[i]['reservation_timestart']  = r.reservation_timestart.substring(0,2) + ":" + r.reservation_timestart.substring(2,4);
                    }
                    if(r.reservation_timeend!=undefined){
                        r.reservation_timeend = '0000' + r.reservation_timeend;
                        r.reservation_timeend = r.reservation_timeend.substring(r.reservation_timeend.length-4,r.reservation_timeend.length);
                        arr[i]['reservation_timeend']  =  r.reservation_timeend.substring(0,2) + ":" + r.reservation_timeend.substring(2,4);       
                    }

                    for(var j=1;j<=5;j++){
                        if(this.headers.some(i=>i.value=='member_form_'+j)){
                            if(arr[i]['member_form_'+j] != undefined && arr[i]['member_form_'+j].length > 0){
                                if(this.registerformlist[j-1].value_type_id==1){
                                    arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',').join(' ')
                                }else if(this.registerformlist[j-1].value_type_id==2){
                                    arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',')[1]
                                }
                            }
                        }
                    }

                })
                this.$store.commit('finishLoading',que)
            })
        },
        onDate(date){
            this.select_date = date.id
            this.onCalendar(this.select_date)

            this.calendar_attrs.forEach((v,i,arr)=>{
                arr[i].highlight = false
            })
            this.calendar_attrs.push({highlight: true,dates: this.select_date})

            var today = new Date()
            today.setHours(today.getHours()+7)
            this.calendar_attrs.push({highlight: {color:'orange',fillMode: 'light'},dates: today.toISOString().substring(0,10)})
        },
        onCalendar(date){
            if(date==null){
                if(this.query.query["datee"] != undefined){
                    delete this.query.query["datee"]
                    var today = new Date()
                    today.setHours(today.getHours()+7)
                    this.query.query['datee_from'] = today.toISOString().substring(0,10)
                }
            }else{
                if(this.query.query["datee_from"] != undefined){
                    delete this.query.query["datee_from"]
                }
                this.query.query["datee"] = date;
            }
            this.reload()
        },
    },
    mounted(){

        var que4 = this.$store.commit('addLoading')
        axios.post(config.api.url.manage.staff.get_savesession,{'savesession_url' : document.location.pathname},{ headers: Staff.getTokenHeader()})
        .then(response => {
            this.$store.commit('finishLoading',que4)
            if(response.data!=null){
                this.query = JSON.parse(response.data)
                this.selectedStatus = this.query.query.status_id_list
            }
            
        
            var que1 = this.$store.commit('addLoading')
            axios.post(config.api.url.public.station.get_registerform,{station_code:this.station_code})
            .then(response => {

                this.registerformlist = response.data.registerformlist

                for(var j=5;j>0;j--){
                    this.header_items.forEach((v,i,arr)=>{
                        if(v.value=='member_form_'+j){
                            if(this.registerformlist.length>=j){
                                arr[i].name = this.$i18n.t('form_tag_'+this.registerformlist[j-1].form_tag)
                            }else{
                                arr.splice(i, 1);
                            }
                        }
                    })
                }

                var k = 1
                this.query.fields.forEach(f=>{
                    var obj = this.header_items.filter(h=>h.value.split('&')[0]==f)
                    if(obj.length>0){
                        this['header_'+k] = obj[0]
                        k+=1
                    }
                })

                this.$store.commit('finishLoading',que1)
                var today = new Date()
                today.setHours(today.getHours()+7)
                this.onCalendar(today.toISOString().substring(0,10))
            })
        })

        var que2 = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.appointment.manage.get_calendar,{station_code:this.station_code},{ headers: Staff.getTokenHeader()})
        .then(response => {
            this.available_dates = []
            response.data.calendars.forEach(car=>{
                car.calendar.forEach(c=>{
                    if(!c.is_close){
                        var datee = new Date(c.datee);
                        datee.setHours(datee.getHours() + 7);
                        this.available_dates.push(datee.toISOString().substring(0,10));
                    }
                })
            })
            //res.json({calendars:Array.from(new Set(result))})
            this.$store.commit('finishLoading',que2)

            this.calendar_attrs.forEach((v,i,arr)=>{
                arr[i].highlight = false
                arr[i].bar = false
                arr[i].popover = {}
            })

            var que3 = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.search_calendar,{
                station_code : this.station_code
                ,query : { station_code_list:[this.station_code] }
            },{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que3)
                response.data.calendar.forEach(c=>{
                    this.calendar_attrs.push({
                        bar: 'purple'
                        ,dates: c.datee
                        ,popover: {
                            label: Object.keys(c.status).reduce((v,k)=> v+c.status[k],0),
                        }
                    })
                })
                if(this.select_date!=null){
                    this.calendar_attrs.push({highlight: true,dates: this.select_date})
                }
                var today = new Date()
                today.setHours(today.getHours()+7)
                this.calendar_attrs.push({highlight: {color:'orange',fillMode: 'light'},dates: today.toISOString().substring(0,10)})
            }).catch(error => {
                this.$router.push({name:'Error',params:error})         
            })

        })
    }
}
</script>